export const ASSET_TYPE_VEHICLE = 'vehicle';
export const ASSET_TYPE_CONTAINER = 'container';
export const ASSET_TYPE_PHONE = 'phone';
export const ASSET_TYPE_CAMERA = 'camera';

export const ASSET_TYPE = {
  [ASSET_TYPE_VEHICLE]: 'vehículo',
  [ASSET_TYPE_CONTAINER]: 'contenedor',
  [ASSET_TYPE_PHONE]: 'celular',
  [ASSET_TYPE_CAMERA]: 'camara',
};
